var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DynamicContent',{attrs:{"title":_vm.title,"contentTypeId":_vm.contentTypeId,"contentTypePermissions":_vm.entryPermissions}})
}
var staticRenderFns = []

export { render, staticRenderFns }